export default __webpack_public_path__ + "static/timesheets-ba3b2bc3eb7f30a60dfd3402042dbac8.png";